import React from 'react';
import { motion } from 'framer-motion';

export function ErpPageHeader({ eyebrow, title, subtitle, actions, icon: Icon }) {
  return (
    <div className="pb-6 flex items-end justify-between flex-wrap gap-4" data-testid="page-header">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="flex items-center gap-4"
      >
        {Icon && (
          <span
            className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0"
            style={{
              background: 'linear-gradient(135deg, var(--gg-accent), #E2C15B)',
              color: '#FFFFFF',
              boxShadow: 'var(--gg-accent-glow)',
            }}
          >
            <Icon size={20} />
          </span>
        )}
        <div>
          {eyebrow && <p className="gg-eyebrow" style={{ color: 'var(--gg-accent)' }}>{eyebrow}</p>}
          <h1 className="gg-hero-title mt-1" style={{ fontSize: 30 }}>{title}</h1>
          {subtitle && <p className="text-sm mt-1" style={{ color: 'var(--gg-text-secondary)' }}>{subtitle}</p>}
        </div>
      </motion.div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function ErpEmpty({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="gg-card p-12 text-center" data-testid="empty-state">
      {Icon && (
        <span
          className="w-16 h-16 rounded-3xl inline-flex items-center justify-center mb-4"
          style={{ background: 'var(--gg-accent-soft)', color: 'var(--gg-accent)' }}
        >
          <Icon size={24} />
        </span>
      )}
      <h3 className="text-lg font-bold" style={{ color: 'var(--gg-text)' }}>{title}</h3>
      {subtitle && <p className="text-sm mt-2 max-w-md mx-auto" style={{ color: 'var(--gg-text-secondary)' }}>{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErpStatChip({ tone = 'neutral', children, testid }) {
  const cls = 'gg-chip gg-chip-' + tone;
  return <span className={cls} data-testid={testid}>{children}</span>;
}

export default ErpPageHeader;
